import { useMemo } from "react";
import { AddressElement as StripeAddressElement } from "@stripe/react-stripe-js";
import type { StripeAddressElementOptions } from "@stripe/stripe-js";
import { usePaywallCheckoutContext } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import { stripeElementsAddressElementModes } from "../../../StripeElements/types";
import { useAddressElementDefaultValues } from "./useAddressElementDefaultValues";
import { useAddressElementDisplay } from "./useAddressElementDisplay";
import { useAddressElementFields } from "./useAddressElementFields";

export const AddressElement = () => {
  const { setMemberAddressAttributes } = usePaywallCheckoutContext();

  const mode = stripeElementsAddressElementModes.billing;
  const fields = useAddressElementFields();
  const display = useAddressElementDisplay();
  const defaultValues = useAddressElementDefaultValues();

  const options = useMemo<StripeAddressElementOptions>(
    () => ({
      mode,
      defaultValues,
      fields,
      display,
    }),
    [mode, defaultValues, display, fields],
  );

  return (
    <StripeAddressElement
      options={options}
      onChange={setMemberAddressAttributes}
    />
  );
};
